import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";

const InsuranceSimulationErrorsModal = ({ show, onHide, errors }) => {
  const { _t } = useTranslator();

  return (
    <Modal className="wrapper-modal" show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{_t("pleaseAddMissingDetailsForInsurance")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="property-errors-main-container mb-2">
          <ul className="" style={{ color: "#c0392b", fontSize: "14px" }}>
            {errors.map((error, index) => (
              <li className="d-flex align-items-center gap-6px" key={index}>
                <img src="/images/red-error.svg" alt="Error" />
                <span>{error}</span>
              </li>
            ))}
          </ul>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default InsuranceSimulationErrorsModal;
